<template>
  <div v-title data-title="安全地图">
    <div class="sms-content-top">
      <div class="content-business business-safe-result" ref="safeResult">
        <div class="content-business-main">
          <div class="main-box">
            <div class="business-cell" v-for="safeResult in safeResults">
              <div class="cell-left">
                <div class="event-level">
                  <div class="event-level-box" @click="toSafeResult(safeResult)">
                    <span class="risk-color" :class="safeResult.colorClass"></span>
                    <span class="risk-name">{{ safeResult.kpiName }}</span>
                    <i class="risk-detail el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="part-bottom">
                  <div class="achievement-index-left">
                    <div class="index-name"><span>目标值 :</span></div>
                    <div class="index-name"><span>实际值 :</span></div>
                  </div>
                  <div class="achievement-index-right">
                    <div class="index-value">
                      <span>{{ safeResult.target }}</span>
                    </div>
                    <div class="index-value">
                      <span>{{ safeResult.actual }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-right">
              </div>
            </div>
          </div>
          <div class="operate">
            <div class="el-date-picker-wrapper">
              <el-date-picker
                v-model="safeResult.dateConfig.currentDateText"
                format="yyyy-MM"
                :editable="false"
                :clearable="false"
                prefix-icon="el-icon-caret-bottom"
                type="month"
                @change="safeResult.dateConfig.onYearMonthChange"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="content-business business-core-risk" ref="coreRisk">
        <div class="content-business-main">
          <div class="main-box">
            <div class="business-cell" v-for="item in coreRisk.pageData">
              <div class="cell-left">
                <div class="event-level">
                  <div class="event-level-box" @click="toCoreRisk(item.coreRisk.code)">
                    <span class="risk-color" :class="item.colorClass"></span>
                    <span class="risk-name">{{ item.coreRisk.name }}</span>
                    <i class="risk-detail el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="part-bottom">
                  <div class="achievement-index-left">
                    <div class="index-name"><span>危险源 :</span></div>
                    <div class="index-name"><span>KPI :</span></div>
                  </div>
                  <div class="achievement-index-right">
                    <div class="index-value">
                      <span class="risk-level-color-red">{{ item.danger.red }}</span>/
                      <span class="risk-level-color-orange">{{ item.danger.orange }}</span>/
                      <span class="risk-level-color-yellow">{{ item.danger.yellow }}</span>/
                      <span class="risk-level-color-green">{{ item.danger.green }}</span>
                    </div>
                    <div class="index-value">
                      <span class="risk-level-color-red">{{ item.kpi.red }}</span>/
                      <span class="risk-level-color-yellow">{{ item.kpi.yellow }}</span>/
                      <span class="risk-level-color-blue">{{ item.kpi.blue }}</span>/
                      <span class="risk-level-color-green">{{ item.kpi.green }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-right">
              </div>
            </div>
          </div>
          <div class="operate">
            <div class="el-date-picker-wrapper">
              <el-date-picker
                v-model="coreRisk.dateConfig.currentDateText"
                format="yyyy-MM"
                :editable="false"
                :clearable="false"
                prefix-icon="el-icon-caret-bottom"
                type="month"
                @change="coreRisk.dateConfig.onYearMonthChange"
              >
              </el-date-picker>
            </div>
            <div class="arrow-box">
              <div class="arrow-left"
                   :class="{'enable':this.coreRisk.hasPreviousPage}"
                   @click="coreRiskPrev">
                <!-- 同一时刻，只有一个img能显示，鼠标悬浮，显示dark-icon，否则显示light-icon-->
                <img src="../../assets/arrow-left.png" class="light-icon" alt="">
                <img src="../../assets/arrow-left-dark.png" class="dark-icon" alt="">
              </div>
              <div class="arrow-right"
                   :class="{'enable':this.coreRisk.hasNextPage}"
                   @click="coreRiskNext">
                <img src="../../assets/arrow-right.png" class="light-icon" alt="">
                <img src="../../assets/arrow-right-dark.png" class="dark-icon" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sms-content-bottom">
      <div class="content-business business-running-overview" ref="runningOverview">
        <div class="content-business-main">
          <div class="operate">
            <div class="el-date-picker-wrapper">
              <el-date-picker
                v-model="operationOverviewConfig.dateConfig.currentDateText"
                format="yyyy-MM"
                :editable="false"
                :clearable="false"
                prefix-icon="el-icon-caret-bottom"
                type="month"
                @change="operationOverviewConfig.dateConfig.onYearMonthChange"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="main-box">
            <!-- remain = 0, kpi数量 = 1：一个kpi独占单元格-->
            <!-- 其余情况：多个kpi共同占满单元格-->
            <div class="business-cell" v-for="cell in operationOverviewConfig.viewCells">
              <div class="cell-left" v-if="cell.remain === 0 && cell.kpis.length === 1">
                <div class="dimension-kpi-box">
                  <div class="kpi-name">{{ cell.kpis[0].kpiName }}</div>
                  <div class="kpi-dimension-table">
                    <div class="kpi-dimension-item" v-for="item in cell.kpis[0].currentMonthValue">
                      <div class="kpi-dimension-value">{{ item.name }}</div>
                      <div class="kpi-actual-value">{{ item.value == null ? '-' : item.value }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-left" v-else>
                <div class="simple-kpi-row" v-for="kpi in cell.kpis">
                  <div class="kpi-name">{{ kpi.kpiName }}</div>
                  <div class="kpi-value">{{ kpi.currentMonthValue == null ? '-' : kpi.currentMonthValue }}
                    {{ kpi.monthValueIncrement != null ? '(' + (kpi.monthValueIncrement) + ')' : '' }}
                  </div>
                </div>
              </div>
              <div class="cell-right">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-business business-key-process" ref="keyProcess">
        <div class="content-business-main">
          <div class="operate">
            <div class="el-date-picker-wrapper">
              <el-date-picker
                v-model="keyProcess.dateConfig.currentDateText"
                format="yyyy-MM"
                :editable="false"
                :clearable="false"
                prefix-icon="el-icon-caret-bottom"
                type="month"
                @change="keyProcess.dateConfig.onYearMonthChange"
              >
              </el-date-picker>
            </div>
            <div class="arrow-box">
              <div class="arrow-left"
                   :class="{'enable':keyProcess.hasPreviousPage}"
                   @click="keyProcessPrev">
                <!-- 同一时刻，只有一个img能显示，鼠标悬浮，显示dark-icon，否则显示light-icon-->
                <img src="../../assets/arrow-left.png" class="light-icon" alt="">
                <img src="../../assets/arrow-left-dark.png" class="dark-icon" alt="">
              </div>
              <div class="arrow-right"
                   :class="{'enable':keyProcess.hasNextPage}"
                   @click="keyProcessNext">
                <img src="../../assets/arrow-right.png" class="light-icon" alt="">
                <img src="../../assets/arrow-right-dark.png" class="dark-icon" alt="">
              </div>
            </div>
          </div>
          <div class="main-box">
            <div class="business-cell" v-for="item in keyProcess.pageData">
              <div class="cell-left">
                <div class="event-level">
                  <div class="event-level-box" @click="toKeyProcess(item.system.code)">
                    <span class="risk-color" :class="item.colorClass"></span>
                    <span class="risk-name">{{ item.system.name }}</span>
                    <i class="risk-detail el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="part-bottom">
                  <div class="achievement-index-left">
                    <div class="index-name"><span>子流程 :</span></div>
                    <div class="index-name"><span>检查 :</span></div>
                    <div class="index-name"><span>KPI :</span></div>
                  </div>
                  <div class="achievement-index-right">
                    <div class="index-value">
                      <span class="risk-level-color-red">{{ item.subProcess.red }}</span>/
                      <span class="risk-level-color-orange">{{ item.subProcess.orange }}</span>/
                      <span class="risk-level-color-yellow">{{ item.subProcess.yellow }}</span>/
                      <span class="risk-level-color-green">{{ item.subProcess.green }}</span>
                    </div>
                    <div class="index-value">
                      <span class="risk-level-color-red">{{ item.check.red }}</span>/
                      <span class="risk-level-color-orange">{{ item.check.orange }}</span>/
                      <span class="risk-level-color-yellow">{{ item.check.yellow }}</span>/
                      <span class="risk-level-color-green">{{ item.check.green }}</span>
                    </div>
                    <div class="index-value">
                      <span class="risk-level-color-red">{{ item.kpi.red }}</span>/
                      <span class="risk-level-color-yellow">{{ item.kpi.yellow }}</span>/
                      <span class="risk-level-color-blue">{{ item.kpi.blue }}</span>/
                      <span class="risk-level-color-green">{{ item.kpi.green }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-right">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sms-content-center-container">
      <div class="left">
        <div class="name">安全结果</div>
        <div class="name">运行概况</div>
      </div>
      <div class="sms-content-center">
        <div class="inner">
          <div class="name">安全</div>
          <div class="name">地图</div>
        </div>
      </div>
      <div class="right">
        <div class="name">核心风险</div>
        <div class="name">关键流程</div>
      </div>
    </div>
    <div class="sms-content-right-container" @click="onSafeMapCaacClick">
      <img src="../../assets/arrow-left.png" class="light-icon" alt="">
      <img src="../../assets/arrow-left-dark.png" class="dark-icon" alt="">
    </div>
  </div>
</template>
<script>
import {getRequest, postRequest} from "../../utils/request";

export default {
  props: {
    company: String,
    year: Number
  },
  data() {
    return {
      safeResults: null,
      coreRisks: null,
      safeResult: {
        //日期组件
        dateConfig: {
          currentDateText: null,
          currentYear: null,
          currentMonth: null,
          onYearMonthChange: (date) => {
            this.safeResult.dateConfig.currentDateText = date.format("yyyy-MM");
            this.safeResult.dateConfig.currentYear = date.getFullYear();
            this.safeResult.dateConfig.currentMonth = date.getMonth() + 1;
            this.buildSafeResult();
          },
        },
      },
      coreRisk: {
        //当前页数据
        pageData: [],
        //全部数据
        all: [],
        pageNum: 1,
        hasNextPage: true,
        hasPreviousPage: true,
        //日期组件
        dateConfig: {
          currentDateText: null,
          currentYear: null,
          currentMonth: null,
          onYearMonthChange: (date) => {
            this.coreRisk.dateConfig.currentDateText = date.format("yyyy-MM");
            this.coreRisk.dateConfig.currentYear = date.getFullYear();
            this.coreRisk.dateConfig.currentMonth = date.getMonth() + 1;
            this.buildCoreRisk();
            //切换时间后，回到第1页
            // this.coreRisk.pageNum = 1;
          },
        },
      },
      keyProcess: {
        //当前页数据
        pageData: [],
        //全部数据
        all: [],
        pageNum: 1,
        hasNextPage: true,
        hasPreviousPage: true,
        //日期组件
        dateConfig: {
          currentDateText: null,
          currentYear: null,
          currentMonth: null,
          onYearMonthChange: (date) => {
            this.keyProcess.dateConfig.currentDateText = date.format("yyyy-MM");
            this.keyProcess.dateConfig.currentYear = date.getFullYear();
            this.keyProcess.dateConfig.currentMonth = date.getMonth() + 1;
            this.buildKeyProcess();
            //切换时间后，回到第1页
            // this.coreRisk.pageNum = 1;
          },
        },
      },
      //运行概况配置
      operationOverviewConfig: {
        //展示单元格
        viewCells: [{
          //包裹的kpi
          kpis: [{
            //当前月份值
            currentMonthValue: null
          }],
        }],
        //日期组件
        dateConfig: {
          currentDateText: null,
          currentYear: null,
          currentMonth: null,
          onYearMonthChange: (date) => {
            this.operationOverviewConfig.dateConfig.currentDateText = date.format("yyyy-MM");
            this.operationOverviewConfig.dateConfig.currentYear = date.getFullYear();
            this.operationOverviewConfig.dateConfig.currentMonth = date.getMonth() + 1;
            this.buildOperationOverview();
          },
        },
      },
    }
  },
  computed: {
    //注：取上个月的值
    currentMonth() {
      return this.operationOverviewConfig.dateConfig.currentMonth;
    },
  },
  mounted() {
    //触发构建重点监控指标和基础指标
    let now = new Date();
    this.safeResult.dateConfig.onYearMonthChange(now);
    this.coreRisk.dateConfig.onYearMonthChange(now);
    this.keyProcess.dateConfig.onYearMonthChange(now);
    this.operationOverviewConfig.dateConfig.onYearMonthChange(now);
  },
  methods: {
    buildSafeResult() {
      getRequest("/map/board/result", {
        year: this.safeResult.dateConfig.currentYear,
        month: this.safeResult.dateConfig.currentMonth,
      }, this.$refs.safeResult)
        .then(res => {
          this.safeResults = res.data
          this.safeResults.forEach((item) => {
            item.colorClass = this.$util.getRiskLevelBgColor(item.levelColor);
            if (item.target == null) item.target = "-";
            if (item.actual == null) item.actual = "-";
          })
        })
    },
    /**
     * 前往新安全地图
     */
    onSafeMapCaacClick() {
      this.$router.push({name: "safeMap"})
    },
    /**
     * 核心风险：下一页
     */
    coreRiskNext() {
      if (this.coreRisk.hasNextPage) {
        this.buildCoreRiskByPage(++this.coreRisk.pageNum);
      }
    },
    /**
     * 核心风险：上一页
     */
    coreRiskPrev() {
      if (this.coreRisk.hasPreviousPage) {
        this.buildCoreRiskByPage(--this.coreRisk.pageNum);
      }
    },
    buildCoreRisk() {
      getRequest("/map/board/risk", {
        company: this.company,
        year: this.coreRisk.dateConfig.currentYear,
        month: this.coreRisk.dateConfig.currentMonth,
      }, this.$refs.coreRisk).then(res => {
        res.data.forEach((item) => {
          item.colorClass = this.$util.getRiskLevelBgColor(item.levelColor);
        })
        this.coreRisk.all = _.chunk(res.data, 9);
        this.buildCoreRiskByPage();
      })
    },
    buildCoreRiskByPage(page = this.coreRisk.pageNum) {
      this.coreRisk.pageData = this.coreRisk.all[page - 1];
      this.coreRisk.hasPreviousPage = this.coreRisk.pageNum - 1 > 0;
      this.coreRisk.hasNextPage = this.coreRisk.pageNum < this.coreRisk.all.length
    },
    /**
     * 构建运行概况
     */
    buildOperationOverview() {
      postRequest("/dwKpiOs/safetyMap/statistics", {
        year: this.operationOverviewConfig.dateConfig.currentYear,
      }, this.$refs.runningOverview).then(res => {
        this.operationOverviewConfig.viewCells = [{kpis: [], remain: 2}];

        res.data.forEach(kpiData => {
          this.appendViewCellForOS(kpiData);
        })
      })
    },
    /**
     * 往运行概况面板追加KPI，直到到达最大容量
     */
    appendViewCellForOS(kpiData) {
      //取最后一格
      let viewCellLength = this.operationOverviewConfig.viewCells.length;
      let viewCell = this.operationOverviewConfig.viewCells[viewCellLength - 1]
      //剩余容量
      let remain = viewCell.remain;
      let dimension = kpiData.dimension;
      //占用容量
      let occupied = !dimension || dimension === "NONE" ? 1 : 2;
      //是否区分维度
      let isDimension = dimension && dimension !== "NONE";
      let kpiName = kpiData.kpiName;
      //还有剩余容量，则添加，容量不够，则另起一格
      if (remain >= occupied) {
        let currentMonthValue;
        let lastMonthValue;
        //增量
        let monthValueIncrement;
        if (!dimension || dimension === "NONE") {
          if (!kpiData.actualValueList || !kpiData.actualValueList.length) {
            currentMonthValue = "该指标未配置";
          } else {
            kpiData.actualValueList.every(actual => {
              //取当前月的值
              if (this.currentMonth === actual.month) {
                currentMonthValue = actual.value;
                return false;
              }
              return true;
            })
            kpiData.actualValueList.every(actual => {
              //取上个月的值
              if (this.currentMonth - 1 === actual.month) {
                lastMonthValue = actual.value;
                return false;
              }
              return true;
            })
            if (currentMonthValue != null && lastMonthValue != null) {
              monthValueIncrement = this.$util.minus(currentMonthValue, lastMonthValue);
            }
          }
        } else {
          if (!kpiData.actualValueList || !kpiData.actualValueList.length) {
            currentMonthValue = [];
          } else {
            kpiData.actualValueList.forEach(actual => {
              //取当前月的值
              if (this.currentMonth === actual.month) {
                currentMonthValue = actual.dimensionValueList;
              }
            });
          }
        }
        let kpi = {
          kpiName,
          isDimension,
          currentMonthValue,
          lastMonthValue,
          monthValueIncrement,
        }
        viewCell.kpis.push(kpi);
        viewCell.remain = remain - occupied;
      } else {
        //超过极限数量，不再追加
        if (viewCellLength === 8) return;
        this.operationOverviewConfig.viewCells.push({kpis: [], remain: 2});
        this.appendViewCellForOS(kpiData);
      }
    },
    /**
     * 关键流程：获取数据
     */
    buildKeyProcess() {
      getRequest("/map/board/keyProcess", {
        year: this.keyProcess.dateConfig.currentYear,
        month: this.keyProcess.dateConfig.currentMonth,
      }, this.$refs.keyProcess).then(res => {
        res.data.forEach((item) => {
          item.colorClass = this.$util.getRiskLevelBgColor(item.levelColor);
        })
        this.keyProcess.all = _.chunk(res.data, 9);
        this.buildKeyProcessByPage();
      })
    },
    buildKeyProcessByPage(page = this.keyProcess.pageNum) {
      this.keyProcess.pageData = this.keyProcess.all[page - 1];
      this.keyProcess.hasPreviousPage = this.keyProcess.pageNum - 1 > 0;
      this.keyProcess.hasNextPage = this.keyProcess.pageNum < this.keyProcess.all.length
    },
    /**
     * 关键流程：下一页
     */
    keyProcessNext() {
      if (this.keyProcess.hasNextPage) {
        this.buildKeyProcessByPage(++this.keyProcess.pageNum);
      }
    },
    /**
     * 关键流程：上一页
     */
    keyProcessPrev() {
      if (this.keyProcess.hasPreviousPage) {
        this.buildKeyProcessByPage(--this.keyProcess.pageNum);
      }
    },
    /**
     * 跳转
     */
    toSafeResult(safeResult) {
      let query = this.enableJumpToSafeResult(safeResult) ? {symptom: safeResult.kpiCode} : null;
      this.$router.push({name: "safeResult", query: query});
    },
    toCoreRisk(code) {
      this.$router.push({name: "coreRisk", query: {code: code}});
    },
    toKeyProcess(code) {
      this.$router.push({name: "keyProcess", query: {code: code}});
    },
    /**
     * 是否支持跳转到安全结果页面
     */
    enableJumpToSafeResult(safeResult) {
      return safeResult.kpiCode !== 'SR-009' && safeResult.kpiCode !== 'SR-001'
    }
  },
  watch: {
    company() {
      this.buildSafeResult();
      this.buildCoreRisk();
      this.buildOperationOverview();
      this.buildKeyProcess();
    }
  }
}
</script>
<style scoped lang="less">
.content-business {
  width: 49.4%;

  &:nth-child(2n-1) {
    margin-right: auto;
  }
}

.sms-content-top {
  margin-bottom: 18px;
  display: flex;

  .content-business-main {
    padding-top: 35px;
    padding-bottom: 15px;
    //确保分页盒子固定在底部
    justify-content: space-between;
    box-sizing: border-box;
  }
}

.sms-content-bottom {
  display: flex;

  .content-business-main {
    padding-top: 15px;
    box-sizing: border-box;

    .operate {
      margin-bottom: 30px;
    }
  }
}

//业务容器公用样式
.content-business-main {
  display: flex;
  flex-direction: column;
  height: 370px;
  background-color: #fff;
  border-radius: 10px;

  .main-box {
    display: flex;
    flex-wrap: wrap;
    margin-left: 35px;

    .business-cell {
      width: (100%/3);
      display: flex;
      align-items: center;
      padding: 0 15px;
      box-sizing: border-box;

      .cell-left {
        width: 99%;

        .event-level {
          margin-bottom: 10px;

          .event-level-box {
            display: flex;
            align-items: center;

            .risk-color {
              width: 12px;
              height: 12px;
              border-radius: 50%;
            }

            .risk-detail {
              font-size: 16px;
              color: #ccc;
            }

            .risk-name {
              padding: 0 8px;
              font-weight: bold;
              font-size: 14px;
              max-width: 82%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .part-bottom {
          display: flex;
          align-items: center;
          font-size: 12px;

          .index-name, .index-value {
            line-height: 20px;
          }

          .index-value {
            span {
              margin: 0 4px;
              font-weight: bold;
            }
          }
        }
      }

      .cell-right {
        width: 1%;
      }
    }
  }

  .operate {
    display: flex;
    height: 30px;
    justify-content: flex-end;

    .arrow-box {
      display: flex;
      align-items: center;

      .arrow-left, .arrow-right {
        height: 100%;
        display: flex;
        align-items: center;

        .light-icon {
          display: inherit;
        }

        .dark-icon {
          display: none;
        }

        &:hover {
          cursor: default;
        }

        &.enable {
          &:hover {
            cursor: pointer;

            .light-icon {
              display: none;
            }

            .dark-icon {
              display: inherit;
            }
          }
        }
      }

      .arrow-left {
        padding-left: 16px;
        padding-right: 6px;
      }

      .arrow-right {
        padding-left: 6px;
        padding-right: 16px;
      }
    }

    //日期选择器定制样式
    .el-date-picker-wrapper {
      width: 140px;

      /deep/ .el-date-editor {
        width: 100%;
      }

      /deep/ .el-input__inner {
        border: none;
        color: #409EFF;
        font-size: 22px;
        font-weight: bold;
      }

      /deep/ .el-input__icon {
        font-size: 22px;
        font-weight: bold;
      }
    }
  }
}

//安全结果、核心风险、关键流程特殊处理
.business-safe-result, .business-core-risk, .business-key-process {
  //除了前3个块，其余都要加上边距
  .business-cell:not(:nth-child(-n+3)) {
    margin-top: 25px;
  }

  //第3，6，9个块不需要加边框
  .business-cell:not(:nth-child(3n)) .cell-right {
    height: 60px;
    border-right: 1px solid #e7e7e7;
  }
}

//安全结果、核心风险特殊处理
.business-safe-result, .business-core-risk, .business-key-process {
  .business-cell {
    .cell-left {
      .event-level {
        .event-level-box {
          &:hover {
            color: #49d58d;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.business-safe-result, .business-running-overview {
  .operate {
    justify-content: flex-start;
    padding-left: 30px;
  }
}

//运行概况
.business-running-overview {
  .content-business-main {
    padding-top: 14px;

    .main-box {
      height: 280px;
      flex-direction: column;

      .business-cell {
        width: 50%;
        height: calc(280px / 4);
        overflow: hidden;

        .cell-left {
          .simple-kpi-row {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .kpi-name {
              font-weight: bold;
              font-size: 14px;
            }

            .kpi-value {
              font-size: 13px;
              font-weight: bold;
            }

            &:not(:first-child) {
              margin-top: 5px;
            }
          }

          .dimension-kpi-box {
            .kpi-name {
              font-weight: bold;
              font-size: 14px;
            }

            .kpi-dimension-table {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 0 10px;

              .kpi-dimension-item {
                text-align: center;

                .kpi-dimension-value {
                  font-size: 13px;
                }

                .kpi-actual-value {
                  font-size: 13px;
                }
              }
            }

            //已废弃
            .kpi-dimension-row {
              display: flex;
              align-items: center;
              justify-content: space-around;

              .kpi-dimension-value {
                //width: 25%;
                //text-align: center;
                font-size: 14px;

                &:not(:last-child) {
                  box-sizing: border-box;
                  border-right: 1px solid #fff;
                }
              }
            }

            //已废弃
            .kpi-actual-value-row {
              display: flex;
              align-items: center;
              justify-content: space-around;

              .kpi-actual-value {
                //width: 25%;
                //text-align: center;
                font-size: 14px;
              }
            }
          }
        }
      }

      //前4个块需要加边框
      .business-cell:nth-child(-n+4) .cell-right {
        height: 30px;
        border-right: 1px solid #e7e7e7;
      }
    }
  }
}

//关键流程
.business-key-process {
  .content-business-main {
    .operate {
      margin-bottom: 20px;
    }

    .main-box {
      .business-cell {
        //提升z轴值，避免被中央大圆绝对定位挡住，导致无法点击
        z-index: 1;

        .cell-left {
          .event-level {
            margin-bottom: 7px;
          }
        }
      }
    }
  }

  //除了前3个块，其余都要加上边距
  .business-cell:not(:nth-child(-n+3)) {
    margin-top: 15px;
  }
}

//中间的大圆
.sms-content-center-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;

  .left, .right {
    flex: 1;
    height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .name {
      font-size: 16px;
      font-weight: bold;
      color: #3A404C;
      margin: 5px 10px;
    }
  }

  .sms-content-center {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 205px;
    height: 192px;
    background: url(../../assets/center_logo.jpg) no-repeat;
    background-size: 100%;


    .inner {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 110px;
      height: 110px;
      background-size: 100%;
      border-radius: 50%;
      background: #f0f1f6 url(../../assets/center_rotate.png) no-repeat;

      .name {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #3A404C;
        margin: -2px 0;
      }
    }
  }
}

//右侧切换按钮
.sms-content-right-container {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-50%, -50%);

  .light-icon {
    display: inherit;
  }

  .dark-icon {
    display: none;
  }

  &:hover {
    cursor: default;
  }

  &:hover {
    cursor: pointer;

    .light-icon {
      display: none;
    }

    .dark-icon {
      display: inherit;
    }
  }

  img {
    width: 30px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/achievement/SafeMap.vue